import React from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

interface IResultMergePurchaseInvoicePdfRecord {
  id: number;
  description: string;
  status: string;
}

interface ITableResultMergePurchaseInvoicePdf {
  records: IResultMergePurchaseInvoicePdfRecord[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
});

const TableResultMergePurchaseInvoicePdf = ({
  records,
}: ITableResultMergePurchaseInvoicePdf) => {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Purchase Invoice Id</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map(
            (record: IResultMergePurchaseInvoicePdfRecord, key: number) => {
              return (
                <TableRow key={`row-${key}`}>
                  <TableCell>{record.id}</TableCell>
                  <TableCell>{record.description}</TableCell>
                  <TableCell>{record.status}</TableCell>
                </TableRow>
              );
            },
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultMergePurchaseInvoicePdf;
